"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Visibilty32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16 8c3.858 0 6.344 1.762 9.563 5.927.242.314.424.552.74.973l.206.277.392.524a.5.5 0 01-.001.599c-.85 1.133-1.028 1.37-1.406 1.855C22.303 22.26 19.828 24 16 24c-3.828 0-6.303-1.74-9.494-5.845-.378-.486-.556-.722-1.406-1.855a.5.5 0 010-.6c.85-1.133 1.028-1.37 1.406-1.855C9.697 9.74 12.172 8 16 8zm0 1c-3.446 0-5.684 1.573-8.705 5.459-.337.433-.514.667-1.17 1.541.656.874.833 1.108 1.17 1.541C10.316 21.427 12.554 23 16 23c3.446 0 5.684-1.573 8.705-5.459.265-.34.43-.558.808-1.06l.229-.304.134-.178a97.51 97.51 0 00-1.104-1.46C21.723 10.594 19.474 9 16 9zm-.001 2.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 1a3.5 3.5 0 10.002 7 3.5 3.5 0 00-.002-7z", className: "visibilty-32_svg__path-1" }))); };
var StyledVisibilty32 = styled_components_1.default(Visibilty32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledVisibilty32;
var templateObject_1;
//# sourceMappingURL=Visibilty32.js.map